var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({staticClass:"remark-box whitespace-nowrap"},on),[_vm._v(_vm._s(_vm.p_text))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.p_text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }